import styled from 'styled-components';
import DocsHome from './DocsHome';

export default styled(DocsHome)`
  height: 100%;
  .docs-home {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    flex-direction: column;
    height: 100%;
    overflow: auto;

    &__loading,
    &__error {
      display: flex;
      grid-column: 1 / span 12;
      grid-row: 1;
      font-size: 1.8rem;
      font-weight: 500;
      justify-content: center;
      margin: 2rem 0;
      text-align: center;
    }

    &__no-match {
      display: flex;
      justify-content: center;
      height: 100%;
      align-items: center;
      color: var(--white);
    }

    &__error {
      color: var(--error900);
      flex-direction: column;
    }

    &__side {
      background: var(--grey700);
      grid-column: 1 / span 3;
      grid-row: 1;
      max-height: 100%;
      overflow-y: scroll;
    }

    &__content {
      grid-column: 4 / span 12;
      grid-row: 1;
      overflow: auto;
    }

    &__bar {
      background: var(--grey900);
      display: flex;
      padding: 1rem;
      justify-content: flex-end;
    }

    &__tip {
      display: flex;
      font-size: 1.8rem;
      font-weight: 500;
      justify-content: center;
      margin: 2rem 5rem;
    }
  }
`;
